import { useEffect } from "react";
import axios from "axios";
import { config } from "../config";

const serverUrl = config.apiURL;

export interface UseTrackPageVisitOptions {
  type?: string;
  product?: string;
  insight_from_date?: string;
  positive?: string;
}

const DEFAULT_TYPE = "tracker_ui_visit";

export function useTrackPageVisit(
  name: string,
  accountId: string,
  options: UseTrackPageVisitOptions = {}
) {
  const {
    type = DEFAULT_TYPE,
    product,
    insight_from_date,
    positive,
  } = options;

  useEffect(() => {
    if (!accountId) return;
    const visitData: Record<string, unknown> = {
      source: "trust",
      type,
      account_identifier: accountId,
      page_name: name,
      url: document.URL,
      additional_data: {
        event_time: new Date(Date.now()).toString(),
      },
    };
    if (product !== undefined) visitData.product = product;
    if (insight_from_date !== undefined)
      visitData.insight_from_date = insight_from_date;
    if (positive !== undefined) visitData.positive = positive;
    axios.post(serverUrl + "/api/web_interactions", visitData);
  }, [accountId, name, type, product, insight_from_date, positive]);
}
